/**
 * @file 组件初始化入口
 */

import TBadge from './badge.vue'

TBadge.install = Vue => {
  Vue.component(TBadge.name, TBadge)
}

export {
  TBadge
}



// WEBPACK FOOTER //
// ./src/module/badge/index.js